export interface AppConfig {
  VITE_API_URL?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const readRuntimeConfig = (key: keyof AppConfig): string | undefined => {
  if (typeof window === "undefined") return undefined;
  const value = window.__APP_CONFIG__?.[key];
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
};

export const getEnv = (key: keyof AppConfig): string => {
  const runtime = readRuntimeConfig(key);
  if (runtime) return runtime;

  const builtIn = import.meta.env[key];
  return typeof builtIn === "string" ? builtIn.trim() : "";
};

/** URL racine de l'API, ex. https://api.yulqo.kdevs.io:3003 */
export const getApiUrl = (): string => getEnv("VITE_API_URL");

/** /api en local (proxy Vite). En prod : host+port de l'API (Coolify :3003). */
export const getBaseApiUrl = (): string => {
  if (!import.meta.env.PROD) return "/api";
  const root = getApiUrl();
  return root ? `${root.replace(/\/$/, "")}/api` : "/api";
};

/** Racine backend pour /uploads et /receipts */
export const getBackendRoot = (): string => {
  if (!import.meta.env.PROD) return "";
  return getApiUrl().replace(/\/$/, "");
};
